import HoldingSettlementPage from './HoldingSettlementPage';

const HoldingSettlementResponse = () => (
    <HoldingSettlementPage
        title="Holding Settlement Response"
        breadcrumbTitle="Holding Settlement Response"
    />
);

export default HoldingSettlementResponse;
